import { BCMSRecord, Branding, BrandingImage, Link, NavLink, StateManager, useBCMSContext, useParams, useStateManager, } from "@bcm-dev/bcms-vite";
import WidgetContainer, { WidgetNavItem } from 'components/shared/containers/WidgetContainer';
import Classes, { Card, CardOnFileMerchant, RecurringPaymentMerchant, Transaction } from "model";
import React from 'react';
import './styles.css';

export default function CardDetailsNavWidget(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  const defaultCard = globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  let cardID = useParams().cardID ?? defaultCard;
  const creditCardOptionOn = globalController.state.branding.options.include_credit_chw23 === "true";

  if(!creditCardOptionOn && cardID === "1") {
    cardID = "0";
  }
  const data = { ...getDefaultData(cardID, globalController), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
  })

  return(
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = (cardID, globalController) => {
  //const inactiveClass = props.inactiveClass ?? "";
  const defaultCard =  globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  let _cardID = cardID ?? defaultCard;
  const creditCardOptionOn = globalController.state.branding.options.include_credit_chw23 !== "false";

  if(!creditCardOptionOn && _cardID === "1") {
    _cardID = "0";
  }
  const card = Card.initByID(_cardID);
  const shouldDisable = card.active === false || card.recentlyAdded === true;
  const digitalCardRoute = !shouldDisable ? `/home/securitytoken/receivetoken/${ cardID }` : "";
  const spendInsightsRoute = !shouldDisable ? `/home/spendinsights/what/${ cardID }` : "";
  const cardOnFileRoute = !shouldDisable ? `/home/cardonfileworkflow/cardonfile/${ cardID }` : "";
  const statementsRoute = !shouldDisable ? `/home/statements/${ cardID }` : "";
  const messagesRoute = !shouldDisable ? `/home/messages/${ cardID }` : "";

  const filterMerchantAlerts = (merchant) => {
    const validStatus = merchant.status === "update card" || merchant.status === "need feedback";
    const merchantCardID = merchant.card ? merchant.card.id : "";
    return _cardID === merchantCardID && validStatus;
  }

  let lengthOfCardOnFileMerchantAlerts = CardOnFileMerchant.initAll()
  .filter(filterMerchantAlerts).length;

  let lengthOfRecurringPaymentAlerts = RecurringPaymentMerchant.initAll()
  .filter(filterMerchantAlerts).length;

  const numberOfCardOnFileMerchantAlerts = lengthOfCardOnFileMerchantAlerts + lengthOfRecurringPaymentAlerts;

  return {
    branding: globalController.state.branding,
    card,
    digitalCardRoute,
    spendInsightsRoute,
    cardOnFileRoute,
    statementsRoute,
    messagesRoute,
    numberOfCardOnFileMerchantAlerts
  };
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data } = useStateManager();
  const { branding, card } = data;
  const options = branding.options;
  const type = card.type;
  const includeRewardsCredit = options.credit_rewards_chw23 !== "false" ? true : false;
  const includeRewardsDebit = options.debit_rewards_chw23 !== "false" ? true : false;
  const rewardsWidgetNavItem = <WidgetNavItem text="Rewards" className="rewards" icon="GiftIcon" dataPoint="card_detail_rewards"/>;

  return (
    <WidgetContainer headerText="Card Details" className="card-details-nav-widget" dataPoint="card_detail_header">
      <Branding id="view_digital_card_chw23"  exp={val => val !== "false"}>
        <WidgetNavItem text="View Digital Card" icon="OutlineCardIcon" dataPoint="card_detail_view_digital" route={ data.digitalCardRoute }/>
      </Branding>
      <Branding id="rewards_chw23"  exp={val => val !== "false"}>
        { type === "credit" && includeRewardsCredit && rewardsWidgetNavItem }
        { type === "debit" && includeRewardsDebit && rewardsWidgetNavItem }
      </Branding>

      <Branding id="spend_insights_chw23"  exp={val => val !== "false"}>
        <WidgetNavItem text="Spend Insights" icon="MoneyLightBulbIcon" dataPoint="card_detail_spend_insights" route={ data.spendInsightsRoute }/>
      </Branding>

      <WidgetNavItem text="Card on File" icon="ShoppingCartIcon" dataPoint="card_detail_card_on_file" route={ data.cardOnFileRoute }>
        <Branding id="push_to_merchant_chw23" exp={ val => val === "true" }>
          { data.numberOfCardOnFileMerchantAlerts > 0 &&
          <div className="card-on-file-bubble set-width">
            <p className="number-of-alerts">{ data.numberOfCardOnFileMerchantAlerts }</p>
          </div>
          }
        </Branding>
      </WidgetNavItem> 
      {
        data.card.type === "credit" && 
        <Branding id="statements_chw23" exp={ val => val !== "false" }>
          <WidgetNavItem text="Statements" icon="MoneyDocumentIcon" dataPoint="card_detail_statements" route={ data.statementsRoute }/>          
        </Branding>
      }

      <Branding id="messages_chw23" exp={val => val !== "false"}>
        <WidgetNavItem text="Messages" icon="EnvelopeIcon" dataPoint="card_detail_messages" route={ data.messagesRoute }/>
      </Branding>
    </WidgetContainer>
  );
}